<template>
  <div class="app container use-pointer">
      <div style="position: fixed; display: block; width: 200px; transform: rotateZ(-5deg);">
        <img width="100%"
             src="../assets/titlelogo.png"
             srcset="../assets/titlelogo.png 1x, ../assets/titlelogo@2x.png 2x, ../assets/titlelogo@3x.png 3x"
             style="filter: drop-shadow(10px 10px 4px rgba(0,0,0,0.4)); pointer-events: none;"
        >
      </div>
      <h1 class="wf-mincho">{{ msg }}</h1>
      本サイトはプレオープン中です。
      <p>
         <input type="button" @click="licenseShow = true" value="ラインセンスポリシー等">
      </p>
<!--      <svg-b-text-button @click="licenseShow = true" sign="popup" width="20vw" height="46" fontweight="Bold" ref="textbutton" :fontsize="22">ⓘ</svg-b-text-button>-->
      <license-view
              v-if="licenseShow === true"
              @hide="licenseShow = false"
              taglabel="各種情報"
              :ppwidth="documentAreaWidth * 0.9"
              :ppheight="documentAreaHeight * 0.9"
              :no-animate="false"
              ref="licenses"
              :messages="licenseText"
      ></license-view>
      <template v-if="mode === 0">

      </template>
      <template v-else>
          <template v-if="listDisplayTool === 0">
               <WorklistCollection
                  class="table_area"
                  v-if="works"
                  :doc-width="docWidth"
                  :transitionUpdate="transitionUpdateFlag"
                  :item-indexes="works"
                  :item-source="worksSource"
                  @popCandidate="popCandidate"
              ></WorklistCollection>
          </template>
          <template v-else>
              <WorklistTable
                  class="table_area"
                  v-if="works"
                  :item-indexes="works"
                  :item-source="worksSource"
              ></WorklistTable>
          </template>
          <div style="display: inline-block; text-align: left; width: 100%; font-size: 0.9em; margin-top: 4px;" :style="toolStyle">
              <div class="tool-frame" @click="sortSetup" ref="sortFrame">
                  <span style="display: inline-block; position: absolute; top: 0; bottom: 0; left: 0; right: 0; margin: auto 4px; height: 1em;">
                      <svg width="1em" height="1em" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <g id="SortIcon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <path d="M34,32 L34,36 L2,36 L2,32 L34,32 Z M26,23 L26,27 L2,27 L2,23 L26,23 Z M35,5 L35,15 L38,15 L34,21 L30,15 L33,15 L33,5 L35,5 Z M26,4 L30,10 L27,10 L27,20 L25,20 L25,10 L22,10 L26,4 Z M18,14 L18,18 L2,18 L2,14 L18,14 Z M10,5 L10,9 L2,9 L2,5 L10,5 Z" id="Combined-Shape" fill="currentColor"></path>
                          </g>
                      </svg>
                  </span>
                  {{"　"+sortTitles[sortKind]}}
              </div>
              <div v-if="sortListPos" class="popup-box" :style="{left: sortListPos.x+'px', bottom: sortListPos.y+'px',}">
                  <template v-for="(item, key) in sortTitles" v-bind="key">
                      <div
                              class="popup-item"
                              :class="[key == sortKind ? 'active' : '']"
                              :style="{ height: listToolItemHeight, paddingTop: '0px', paddingBottom: '1px'}"
                              @click="sortKindClick(key)"
                      >
                      {{item}}
                      </div>
                  </template>
              </div>
              <div v-if="authors" class="tool-frame" @click="authorsSetup" ref="authorsFrame">
                  <span style="display: inline-block; position: absolute; top: 0; bottom: 0; left: 0; right: 0; margin: auto 4px; height: 1em;">
                      <svg width="1em" height="1em" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <g id="AuthorIcon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <g id="Combined-Shape-2" transform="translate(5.000000, 3.000000)" fill="currentColor">
                                  <path d="M7.52796495,16.9905963 C5.95373446,15.1886464 5,12.8307015 5,10.25 C5,4.58908131 9.58908131,-9.23705556e-14 15.25,-9.23705556e-14 C20.9109187,-9.23705556e-14 25.5,4.58908131 25.5,10.25 C25.5,12.9241405 24.4759519,15.3591017 22.798617,17.1841224 C27.1169355,19.8174989 30,24.5720615 30,30 C30,31.7531771 29.6992289,33.4361054 29.1464715,35 L0.853528539,35 C0.300771106,33.4361054 0,31.7531771 0,30 C0,24.4363468 3.02903737,19.5801631 7.52796495,16.9905963 L7.52796495,16.9905963 Z" id="Combined-Shape"></path>
                              </g>
                          </g>
                      </svg>
                  </span>
                  {{"　"+authors[authorIndex]}}
              </div>
              <div v-if="authorsPos" class="popup-box" :style="{left: authorsPos.x+'px', bottom: authorsPos.y+'px',}">
                  <template v-for="(item, index) in authors" v-bind="'key'+index">
                      <div
                              class="popup-item"
                              :class="[index === authorIndex ? 'active' : '']"
                              :style="{ height: listToolItemHeight, paddingTop: '0px', paddingBottom: '1px'}"
                              @click="authorsClick(index)"
                      >
                          {{item}}
                      </div>
                  </template>
              </div>
          </div>
      </template>
      <transition name="bottom" @before-enter="popuped = false" @after-enter="popuped = true" @before-leave="popuped = false">
          <candidate-pop v-if="candidate!==null"
                         :work-index="candidate"
                         :work="worksSource[candidate]"
                         :bg-vis="popuped"
                         @hide="backclick"
                         @openWork="openWork"
                         @affiLink="affiLinkClick"
          />
      </transition>
  </div>
</template>

<script>
let debugOut = false
const zlib = require('zlib')
import LicenseView from "@/components/LicenseView"
import WorklistCollection from "@/components/WorklistCollection"
import WorklistTable from "@/components/WorklistTable"
import CandidatePop from "@/components/CandidatePop"
// import SVGBTextButton from "@/components/SVGBTextButtonSlot"
import {mapState} from 'vuex'
export default {
  name: "HelloWorld",
  components: {
    LicenseView,
    WorklistCollection,
    WorklistTable,
    CandidatePop,
    // SVGBTextButton,
  },
  created() {
    debugOut = this.$root.$options.debugOut
  },
  data() {
    return {
      mode:0,
      licenseShow: {
        type: Boolean,
        default: false,
      },
      works:null,
      worksSource:null,
      recommendList:null,
      authors:null,
      listToolItemHeight:'1.5em',
      listDisplayTool:0,
      sortKind:0,
      sortTitles:["公開日付が新しい順","公開日付が古い順","作品名","著者名","初回公開日付が新しい順"],
      sortListPos: null,
      authorIndex:0,
      authorsPos: null,
      candidate: null,

      popuped: false,
      transitionUpdateFlag: 0,
    }
  },
  props: {
    msg: String,
    licenseText: Array,
    docWidth: Number,
    licenseDisplay: Number,
  },
  watch: {
    licenseDisplay(nValue,oValue) {
      if (nValue === oValue) return
      this.licenseShow = true
    },
  },
  mounted() {
    if (debugOut) { console.log("hello world !!") }
    this.setupWorks()
  },
  computed: {
    cyappVersion() {
      return this.$root.$options.cyappVersion
    },
    papiDir() {
      return this.$root.$options.commandPath
    },
    toolStyle() {
      return {
        '--popup-list-cell-height': this.listToolItemHeight,
      }
    },
     ...mapState([
      'documentAreaWidth',
      'documentAreaHeight',
    ]),
  },
  methods: {
    popupStart() {
      if (debugOut) {console.log('popupStart')}
      this.popuped = false
    },
    popupEnd() {
      if (debugOut) {console.log('popupEnd')}
      this.popuped = true
    },
    async setupWorks() {
      this.works = null
      let result = await this.collectWorks().catch(reason => { return })
      this.recommendList = result.recommend || []
      this.mode = (this.recommendList.length === 0) ? 1 : 0
      if (debugOut) {console.log(`recommend:${this.recommendList}`)}
      if (result.comp) {
        let jsontext = zlib.inflateSync(new Buffer(result.works, 'base64')).toString('utf-8')
        if (debugOut) {console.log(jsontext)}
        this.worksSource = JSON.parse(jsontext)
      } else {
        this.worksSource = result.works
        if (debugOut) {console.log(JSON.stringify(this.worksSource))}
      }
      let authors = new Set([])
      this.worksSource.forEach((value) => {
        authors.add(value.info.author)
      })
      authors = Array.from(authors).sort((a,b) => {
        return (a < b) ? 1 : -1
      })
      if (authors.length === 0) {
        this.authors = null
      } else {
        authors.unshift('著作者指定なし')
        this.authors = authors
      }
      this.sortWorks()
    },
    sortSetup() {
      let x = this.$refs.sortFrame.getBoundingClientRect().left + window.pageXOffset
      this.sortListPos = {x:x, y:0}
      this.authorsPos = null
    },
    sortKindClick(i) {
      this.sortListPos = null
      if (this.sortKind !== i) {
        this.sortKind = i
        this.sortWorks()
      }
    },
    authorsSetup() {
      let x = this.$refs.authorsFrame.getBoundingClientRect().left + window.pageXOffset
      this.sortListPos = null
      this.authorsPos = {x:x, y:0}
    },
    authorsClick(i) {
      this.authorsPos = null
      if (this.authorIndex !== i) {
        this.authorIndex = i
        this.sortWorks()
      }
    },
    sortWorks() {
      //{"dir":"ディレクトリ名","info":{"title":"タイトル","main_caption":"説明","author":"著者","vers":1,"pubtime_js":1587706234392,"pubtime_php":"1587706234","o_pubtime_php":"1585911138"}}
      if (this.authorIndex === 0) {
        this.works = [...Array(this.worksSource.length).keys()]
      } else {
        let a = this.authors[this.authorIndex]
        let works = []
        this.worksSource.forEach((v,i) => {
          if (v.info.author === a) {
            works.push(i)
          }
        })
        this.works = works
      }

      let sortFunc
      let getTitle = (oi) => {
        let o = this.worksSource[oi]
        let name = o.info.seriesname || ""
        let num = o.info.seriesnumber || 0

        return ((name !== "") && (num !== 0)) ? {'series':true, 'title':name } : {'series':false, 'title':o.info.title }
      }
      let titleSort = (ai,bi) => {
        let titleA = getTitle(ai)
        let titleB = getTitle(bi)
        if (titleA.title === titleB.title) {
          let a = this.worksSource[ai]
          let b = this.worksSource[bi]
          if (titleA.series && titleB.series) {
            return b.info.seriesnumber - a.info.seriesnumber
          } else {
            return b.info.pubtime_php - a.info.pubtime_php
          }
        } else {
          return (titleA.title < titleB.title) ? 1 : -1
        }
      }
      switch (this.sortKind) {
        case 0:  //"公開日付が新しい順"
          sortFunc = (ai,bi) => {
            let a = this.worksSource[ai]
            let b = this.worksSource[bi]
            return b.info.pubtime_php - a.info.pubtime_php
          }
          break
        case 1:  //"公開日付が古い順"
          sortFunc = (ai,bi) => {
            let a = this.worksSource[ai]
            let b = this.worksSource[bi]
            return a.info.pubtime_php - b.info.pubtime_php
          }
          break
        case 2:  //"作品名"
          sortFunc = titleSort
          break
        case 3:  //"著者名"
          sortFunc = (ai,bi) => {
            let a = this.worksSource[ai]
            let b = this.worksSource[bi]
            if (a.info.author === b.info.author) {
              return titleSort(ai,bi)
            } else {
              return (a.info.author < b.info.author) ? 1 : -1
            }
          }
          break
        case 4:  //"初回公開日付が新しい順"
          sortFunc = (ai,bi) => {
            let a = this.worksSource[ai]
            let b = this.worksSource[bi]
            return b.info.o_pubtime_php - a.info.o_pubtime_php
          }
          break
      }
      this.works.sort(sortFunc)
      this.transitionUpdateFlag = (this.transitionUpdateFlag + 1) % 10
    },
    collectWorks() {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest()
        let options = "all"

        xhr.onload = (e) => {
          // if (debugOut) {console.log(xhr.responseText)}
          let r = JSON.parse(xhr.responseText)
          if ('success' in r) {
            if (!r.success) {
              r.error = e
              reject(r)
            } else {
              resolve(r)
            }
          }
        }
        xhr.onerror = (e) => { reject({success:false, message:'Error detected!', error:e})}
        xhr.onabort = (e) => { reject({success:false, message:'Aborted!', error:e})}
        xhr.ontimeout = (e) => {reject({success:false, message:'Timeout detected!', error:e})}

        xhr.open('POST', `${this.papiDir}/collectworks.php`, true)
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        xhr.setRequestHeader('Pragma', 'no-cache')
        xhr.setRequestHeader('Cache-Control', 'no-cache')
        xhr.send(`Option=${options}`)
      })

    },
    popCandidate(i) {
      this.candidate = Number(i)
    },
    backclick() {
      this.candidate = null
    },
    openWork(i) {
      if (debugOut) {console.log(`open work : index ${i}`)}
      let d = this.worksSource[i].dir
      let t = this.worksSource[i].info.title
      // "dat00002581-00000400tad"
      let a = parseInt(d.substr(3,8),16)
      let w = parseInt(d.substr(12,8),16)
      this.$emit('openWork',a,w,t)
    },
    affiLinkClick(a,p) {
        this.$emit('affiLink',a,p)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .container {
        position: relative;
        /*top: var(--app-info-header-height)px;*/
        /*height: calc(98vh - var(--app-info-header-height));*/
    }

    .container::before {
        display: block;
        width: 100vw;
        height: 100vh;
        content: " ";
        position: fixed;
        background: url(../assets/titlelogo.jpg);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        background-attachment: fixed;
        opacity: .2;
        z-index: -1;
    }

    .table_area {
        display: block;
        position: relative;
        height: calc(100vh - 220px);
        /*height: 100%;*/
        width: 100%;
        /*top: 128px;*/
    }

    .tool-frame {
        display: inline-block;
        padding: 1px 8px;
        border: groove 1px #00008b;
        border-radius: 3px;
        position: relative;
        margin-left: 4px;
        vertical-align: middle;
    }

    .popup-box {
        position: absolute;
        border: solid 1px black;
        background-color: rgba(255, 255, 255, 0.85);
        padding: 4px 2px;
        filter: drop-shadow(2px 2px 1px rgba(0,0,0,0.4));
        z-index: 10;
    }

    .popup-item {
        height: var(--popup-list-cell-height);
        padding: 0px 8px;
        &:not(.active):hover {
            background-color: #c0c0c0;
            cursor: pointer;
        }

        &.active {
            color: #fff;
            background-color: #182a4b;
        }
    }

    .bottom-enter-active, .bottom-leave-active {
        transform: translate(0px, 0px);
        transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    }

    .bottom-enter, .bottom-leave-to {
        transform: translateY(100vh) translateY(0px);
    }
</style>
